import { render, staticRenderFns } from "./ProductFaq.vue?vue&type=template&id=9c18a22e&scoped=true&"
import script from "./ProductFaq.vue?vue&type=script&lang=js&"
export * from "./ProductFaq.vue?vue&type=script&lang=js&"
import style0 from "./ProductFaq.vue?vue&type=style&index=0&id=9c18a22e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../b_front/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c18a22e",
  null
  
)

export default component.exports